import { AdminCellarAddComponent } from './admin-cellar-add/admin-cellar-add.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { TalcColor } from 'src/app/shared';
import { StockItem } from 'src/app/core';
import { SubSink } from 'subsink';
import { StockService } from 'src/app/feature/services';

@Component({
  templateUrl: './cellar.component.html',
  styleUrls: ['./cellar.component.scss'],
})
export class CellarComponent implements OnInit {
  public groupedTypings: { [key: string]: StockItem[] } = {};
  public talcColors: TalcColor[] = [];
  public bindings: StockItem[] = [];
  public typings: StockItem[] = [];
  private subsink = new SubSink();

  public dialogConfig: MatDialogConfig = {
    width: '80%',
    height: '100%',
    maxWidth: '800px',
    maxHeight: '600px',
  };
  ngOnInit(): void {}

  constructor(
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    private stockService: StockService
  ) {
    this.subsink.sink = activatedRoute.data.subscribe({
      next: (data) => {
        this.setValues(data);
      },
    });

    this.subsink.sink = this.activatedRoute.queryParams.subscribe(
      (params: any) => {
        if (params['mode']) {
          if (params['mode'] === 'add') {
            this.openAddDialog(params['target']);
          } else if (
            params['mode'] === 'edit' &&
            params['target'] &&
            params['pointer']
          ) {
            this.openEditDialog(params['target'], params['pointer']);
          }
        }
      }
    );
  }

  setValues(data: any) {
    if (data['typings']) {
      this.typings = data['typings'];
      this.setTyping(this.typings);
    }

    if (data['bindings']) {
      this.bindings = data['bindings'].filter(
        (stock: StockItem) => stock.isBinding
      );
    }

    if (data['colors']) {
      // this.talcColors = data['colors'];
      let colors: Array<any> = [];
      data['colors']?.forEach((color: any) => {
        if (colors.find((c) => c?.colorCode === color?.colorCode)) return;
        else colors.push(color);
      });
      this.talcColors = [...colors];
    }
  }

  openAddDialog(target: string) {
    this.dialog
      .open(AdminCellarAddComponent, {
        ...this.dialogConfig,
        data: {
          target,
        },
      })
      .afterClosed()
      .subscribe(() => {
        this.router.navigate(['admin/cellar']);
        this.updateStockTables();
      });
  }

  updateStockTables() {
    this.stockService.all().subscribe((res) => {
      console.log(res);
      const data = {
        typings: res.filter(type => !type.isBinding && type?.name === 'A3' || type?.name === 'A4' || type?.name === 'A5' ),
        bindings: res.filter(type => type.isBinding ),
        // colors: res.filter(type => !type.isBinding && type?.name === 'A3' || type?.name === 'A4' || type?.name === 'A5' ),
      };
      this.setValues(data);
    });
  }

  openEditDialog(target: string, pointer: string) {
    this.dialog
      .open(AdminCellarAddComponent, {
        ...this.dialogConfig,
        data: {
          target,
          pointer,
          editMode: true,
        },
      })
      .afterClosed()
      .subscribe({
        next: () => {
          this.router.navigate(['admin/cellar']);
          this.updateStockTables();
        },
      });
  }

  public setTyping(items: StockItem[]) {
    items.forEach((item) => {
      if (item.isBinding) {
        return;
      }

      if (this.groupedTypings[item['name']]) {
        this.groupedTypings[item['name']].push(item);
      } else {
        this.groupedTypings[item['name']] = [item];
      }
    });
  }

  public getTypingsKeys() {
    return Object.keys(this.groupedTypings);
  }

  public getTypeName(type: StockItem['type']) {
    switch (true) {
      case type?.endsWith('bw'):
        return 'سیاه و سفید';

      case type?.endsWith('hc'):
        return 'نیمه رنگی';

      case type?.endsWith('c'):
        return 'رنگی';

      default:
        throw new Error('Error in type definition: ' + type);
    }
  }

  public openTypeEdit(pointer: string) {
    this.router.navigate(['admin/cellar'], {
      queryParams: {
        target: 'type',
        pointer,
        mode: 'edit',
      },
    });
  }

  public openBindingAdd() {
    this.router.navigate(['admin/cellar'], {
      queryParams: {
        target: 'binding',
        mode: 'add',
      },
    });
  }

  public openBindingEdit(id: string | number) {
    if(id== 'bindingSalaryFee'){
      this.router.navigate(['admin/cellar'], {
        queryParams: {
          target: 'bindingSalaryFee',
          pointer: 'orderConf',
          mode: 'edit',
        },
      });
    }else
    this.router.navigate(['admin/cellar'], {
      queryParams: {
        target: 'binding',
        pointer: id,
        mode: 'edit',
      },
    });
  }

  public openColorAdd() {
    this.router.navigate(['admin/cellar'], {
      queryParams: {
        target: 'color',
        mode: 'add',
      },
    });
  }

  public openColorEdit(id: number) {
    this.router.navigate(['admin/cellar'], {
      queryParams: {
        target: 'color',
        pointer: id,
        mode: 'edit',
      },
    });
  }
}
